// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3Pjpy","actionsCol":"EnrolledClinics_actionsCol__106xC"};